import { render, staticRenderFns } from "./Flavor.vue?vue&type=template&id=59161a7a&scoped=true&"
import script from "./Flavor.vue?vue&type=script&lang=js&"
export * from "./Flavor.vue?vue&type=script&lang=js&"
import style0 from "./Flavor.vue?vue&type=style&index=0&id=59161a7a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59161a7a",
  null
  
)

export default component.exports